import { render, staticRenderFns } from "./CollegeChoose.vue?vue&type=template&id=5b234a09&scoped=true&"
import script from "./CollegeChoose.vue?vue&type=script&lang=js&"
export * from "./CollegeChoose.vue?vue&type=script&lang=js&"
import style0 from "./CollegeChoose.vue?vue&type=style&index=0&id=5b234a09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b234a09",
  null
  
)

export default component.exports